<template>
  <div
    class="promo-timer f f--m"
    :style="{
      backgroundColor: bgColor,
      color: textColor
    }"
  >
    <UiPicture
      v-if="images"
      :data="images"
      width="24"
      height="24"
      class="promo-timer__picture"
    />

    <span class="promo-timer__text">
      {{ text }}
    </span>

    <UiTimer
      :timer="time"
      class="promo-timer__time"
    />
  </div>
</template>

<script setup lang="ts">
  import type { Images } from '@academica-box/components/Media/UiPicture/types'

  import UiPicture from '@academica-box/components/Media/UiPicture/UiPicture.vue'
  import UiTimer from '@academica-box/components/Notifications/UiTimer/UiTimer.vue'

  const props = defineProps<{
    images?: Images;
    endPromotionDate?: string;
    bgColor: string;
    text?: string;
    textColor?: string;
  }>()

  const time = computed(() => {
    return props.endPromotionDate ? Number(new Date(props.endPromotionDate)) - Number(new Date()) : undefined
  })
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiMedia' as *;
  @use '@academica-box/styles/UiTypography/mixins/_f' as *;

  .promo-timer {
    @include f--3;

    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 6px;
    padding-bottom: 6px;

    @include media(lg) {
      @include f--2;
    }
  }

  .promo-timer__picture {
    width: 24px;
    height: 24px;
    margin-right: 8px;

    @include media(lg) {
      width: 28px;
      height: 28px;
    }
  }

  .promo-timer__text {
    margin-right: 4px;
  }

  .promo-timer__time {
    width: 116px;

    @include media(lg) {
      width: 132px;
    }
  }
</style>
